<span class="status-badge" [ngClass]="'tone-' + tone">{{ status }}</span>
